import React, { useState } from "react";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { searchBoxStyle } from "./constants";

const SearchInput = ({
  value,
  onChange,
  onClear,
  placeholder = "Search...",
  style = {},
  onFocus,
  onBlur,
  onClick,
  endAdornment,
  ...props
}) => {
  const [isInputActive, setIsInputActive] = useState(false);

  const handleInputFocus = (e) => {
    setIsInputActive(true);
    if (onFocus) onFocus(e);
  };

  const handleInputBlur = (e) => {
    setIsInputActive(false);
    if (onBlur) onBlur(e);
    if (onClick) onClick();
  };
  const handleClearClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClear) {
      onClear();
    }
    setIsInputActive(false);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <InputBase
        value={value}
        onChange={onChange}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        className={searchBoxStyle}
        placeholder={placeholder}
        inputProps={{ "aria-label": placeholder }}
        startAdornment={<SearchIcon style={{ color: "#9CA3AF", marginRight: 6 }} />}
        endAdornment={
          endAdornment ||
          (isInputActive || value ? (
            <CloseIcon style={{ cursor: "pointer", color: "#9CA3AF" }} onClick={handleClearClick} />
          ) : null)
        }
        {...props}
      />
      {/* <div style={{ display: 'flex', alignItems: 'center', }}>
        <img
          title="Move Window"
          onClick={onClick}
          src="/Filter.png"
          alt="Move"
          style={{
            // marginBottom: 3,
            marginRight: '8px',
            width: 22,
            height: 22,

            cursor: 'pointer',
            color: InstaColors.primary,
          }}
        />
        <span style={{
           fontFamily: fontFamily, // Add this line
           fontWeight: 300, fontSize: 14,
           color:InstaColors.primary ,
           textOverflow: 'ellipsis',
           textTransform: 'none'
        }}> Add Filter</span>
      </div> */}
    </div>
  );
};

export default SearchInput;
